import { makeInternalAPIRequest } from 'lib/http/ApiProvider'
import Response from 'lib/http/Response'

export const createUser = (user: Record<string, unknown>): Promise<Response> =>
	makeInternalAPIRequest('post', '/auth', user)

export const getUnions = (country: string): Promise<Response> =>
	makeInternalAPIRequest('get', `/unions/${country}`)
